import { createStyles } from "@mantine/core";
import { colors, pxToRem } from "theme";

export const useStyles = createStyles((theme) => ({
  errorIcon: {
    color: colors.iconDestructive,
    width: pxToRem[20],
    marginTop: pxToRem[4],
  },
  error: {
    color: colors.iconDestructive,
  },
}));
